exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Days-module__wrapper___31eSm{display:grid;grid-template-columns:repeat(7,minmax(0,1fr));align-items:center;gap:1em}.Days-module__wrapper___31eSm .Days-module__day-wrapper___3iVDG{display:grid;gap:.5em}.Days-module__wrapper___31eSm .Days-module__day-wrapper___3iVDG .Days-module__day___jPCm1{padding:.5em;text-align:center;font-size:14px}.Days-module__item___2dMUb,.Days-module__wrapper___31eSm .Days-module__day-wrapper___3iVDG .Days-module__day___jPCm1{border-radius:4px;color:#fff;background:#bdccd4}.Days-module__item___2dMUb p{min-height:18px;text-align:center}", ""]);

// exports
exports.locals = {
	"wrapper": "Days-module__wrapper___31eSm",
	"day-wrapper": "Days-module__day-wrapper___3iVDG",
	"day": "Days-module__day___jPCm1",
	"item": "Days-module__item___2dMUb"
};